import React from "react";
import "../styles/Whatsapp.css";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PropTypes from "prop-types";

const WhatsAppButton = (props) => {
  const { id, srOnly, message } = props;

  const phoneNumber = "59891299790";
 
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  return (
    <a
      href={whatsappLink}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat en WhatsApp"
      id={id}
    >
      <span className="sr-only">{srOnly}</span>
      <WhatsAppIcon sx={{ color: "#fafafa" }} />
    </a>
  );
};
WhatsAppButton.propTypes = {
  id: PropTypes.string.isRequired,
  srOnly: PropTypes.string.isRequired,
};

export default WhatsAppButton;
